import React from 'react';

export class SmallUnderline extends React.Component {

  constructor(props) {
    super(props);

    let align;

    switch(this.props.align){
      case "right":
        align = "flex-end";
        break;
      case "left":
        align = "flex-start";
        break;
      case "flex-end":
      case "flex-start":
      case "center":
        align = this.props.align;
        break;
      default:
        align = "center";
    }

    this.alignment = {
      "alignItems": align
    };
  }

  render(){
    return (
      <div className={"small-underline-container " + this.props.className } style={{ ...this.alignment }}>
        {this.props.children}
        <div className="small-underline"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/SmallUnderline.js